import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { endAlertUrl } from '../../config';
import { Status } from '../../common/constants';
import { RootState } from '../../store';
import { IInitialSliceState } from '../../common/types/commonTypes';
import api from '../../api';

const initialState: IInitialSliceState = {
  status: null,
  error: null,
  msg: null,
};

interface IEndAlertResponse {
  message: string;
}

interface IEndAlertModalPayload {
  alertId?: string;
  alertHistoryId?: string;
}

export const endAlertModal = createAsyncThunk(
  'endAlert',
  async (
    endAlertModalPayload: IEndAlertModalPayload,
    { rejectWithValue }
  ) => {
    const { alertId, alertHistoryId } = endAlertModalPayload;

    try {
      const urlSearchParams = new URLSearchParams();

      if (alertHistoryId) {
        urlSearchParams.append('alertHistoryId', alertHistoryId);
      } else if (alertId) {
        urlSearchParams.append('alertId', alertId);
      } else {
        return rejectWithValue({
          response: {
            data: {
              message: 'Alert id or alert history id is required.',
            },
          },
        });
      }

      const response = await api.post<IEndAlertResponse>(
        `${endAlertUrl}?${urlSearchParams.toString()}`
      );

      const endAlertResponse: IEndAlertResponse = response.data;
      return endAlertResponse;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const endAlertModalSlice = createSlice({
  name: 'endAlert',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(endAlertModal.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(endAlertModal.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.status = Status.SUCCESS;
      })
      .addCase(endAlertModal.rejected, (state, action) => {
        const errorPayload = action.payload as {
          response?: {
            data?: {
              error?: {
                message?: string;
              };
              message?: string;
            };
          };
        };

        state.msg =
          errorPayload.response?.data?.error?.message ||
          errorPayload.response?.data?.message ||
          'Unknown error occurred';
        state.status = Status.FAILED;
      });
  },
});

export const selector = (state: RootState) => state.endAlertApi;

export const reducer = endAlertModalSlice.reducer;